import React from 'react';
import { RoleAiMarketplace } from '@/components/ai/RoleAiMarketplace';

/**
 * Prospect AI Tools Marketplace
 * Prospects (athletes) have 4 tool slots: 2 AI (creative) + 2 SmartBlock (trackers)
 */
export default function ProspectAiMarketplace() {
  return (
    <div className="mx-auto max-w-5xl">
      <RoleAiMarketplace
        role="prospect"
        title="AI Tools Marketplace"
        description="Equip your locker room with AI tools for highlights and profile building, plus SmartBlock trackers to measure your training efficiency and performance growth."
      />
    </div>
  );
}
